import { createContext, useContext } from 'react';
import type { FeatureFlagsResult } from '../../types';

/**
 * Context used to provide the value for feature flags from PostHog app-wide.
 *
 * Meant to only ever be set at `root.tsx` so that it'll be available everywhere
 */
export const FeatureFlagsContext = createContext<
  FeatureFlagsResult | undefined
>(undefined);

/**
 * Hook to access feature flags from PostHog anywhere hooks can be used.
 *
 * For server-side usage (ie. loaders and actions), see `getFeatureFlags()` (`@findigs/api/index.server`) and `isFeatureFlagEnabled()` (`@findigs/helpers/src/integrations/posthog/is-feature-flag-enabled`).
 */
export function useFeatureFlags(): FeatureFlagsResult | undefined {
  return useContext(FeatureFlagsContext);
}
